var React = require('react');

function ShareFbWhite (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"#fff","x":"0","y":"0","width":"19","height":"19","rx":"9.5","key":0}),React.createElement("path",{"d":"M11.6708 8.24583H10.0875V7.21667C10.0875 6.82083 10.3646 6.74167 10.5229 6.74167C10.7208 6.74167 11.6312 6.74167 11.6312 6.74167V5H10.0875C8.34583 5 7.98958 6.30625 7.98958 7.09792V8.24583H7V10.0271H7.98958C7.98958 12.3229 7.98958 15.0542 7.98958 15.0542H10.0875C10.0875 15.0542 10.0875 12.2833 10.0875 10.0271H11.5125L11.6708 8.24583Z","fill":"#141B2B","key":1})]);
}

ShareFbWhite.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","version":"1.1"};

module.exports = ShareFbWhite;

ShareFbWhite.default = ShareFbWhite;
